import userService from '@/services/user-service';
import { useQuery } from '@tanstack/react-query';

export type WebsiteConfig = {
  siteName: string;
  siteSubtitle: string;
  logo: string;
};

export const DEFAULT_WEBSITE_CONFIG: WebsiteConfig = {
  siteName: '新范式 ASI',
  siteSubtitle: '知识智能平台',
  logo: '/xfs-logo.png',
};

export type PublicSystemConfig = {
  registerEnabled: number;
  smsLoginEnabled: boolean;
  website: WebsiteConfig;
};

const normalizeSystemConfig = (config?: Partial<PublicSystemConfig>) => ({
  registerEnabled: config?.registerEnabled ?? 0,
  smsLoginEnabled: config?.smsLoginEnabled ?? false,
  website: {
    ...DEFAULT_WEBSITE_CONFIG,
    ...(config?.website ?? {}),
  },
});

/**
 * Hook to fetch public system configuration for the login page.
 * @returns System configuration with loading status
 */
export const useSystemConfig = () => {
  const { data, isLoading } = useQuery({
    queryKey: ['systemConfig'],
    queryFn: async () => {
      const { data = {} } = await userService.getSystemConfig();
      return normalizeSystemConfig(data.data);
    },
  });

  return {
    config: data ?? normalizeSystemConfig(),
    loading: isLoading,
  };
};

export const useWebsiteConfig = () => {
  const { config, loading } = useSystemConfig();
  return { website: config.website, loading };
};
